import { useState } from "react";
import { inputCls, labelCls, TERRITORIES } from "./constants";

export function ServiceRestrictions({ album, setA, services, testIdPrefix = "services" }) {
  const [query, setQuery] = useState("");
  const denied = new Set(album.restrictions.services_denied);
  const q = query.trim().toLowerCase();
  const filtered = q ? services.filter((s) => s.toLowerCase().includes(q)) : services;
  // Select All ticks EVERY checkbox (adds every service to denies).
  // Deny All unticks every checkbox (empties the denies list).
  const selectAll = () => setA("restrictions", { ...album.restrictions, services_denied: [...services] });
  const denyAll = () => setA("restrictions", { ...album.restrictions, services_denied: [] });

  return (
    <div>
      <div className="flex items-end justify-between gap-3 mb-2">
        <label className={labelCls + " mb-0"}>Music service restrictions — check services you want to block</label>
        <div className="flex items-center gap-3 text-[11px]">
          <span className="text-slate-500" data-testid={`${testIdPrefix}-denied-count`}>{denied.size} / {services.length} blocked</span>
          <button type="button" data-testid={`${testIdPrefix}-select-all`} onClick={selectAll} className="text-blue-400 hover:text-blue-300">Select All</button>
          <button type="button" data-testid={`${testIdPrefix}-deny-all`} onClick={denyAll} className="text-slate-400 hover:text-white">Deny All</button>
        </div>
      </div>
      <input
        data-testid={`${testIdPrefix}-search`}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={`Search ${services.length}+ stores`}
        className={inputCls + " mb-3"}
      />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 max-h-[300px] overflow-y-auto pr-1">
        {filtered.map((s) => {
          const isDenied = denied.has(s);
          return (
            <label key={s} className={`cursor-pointer rounded-xl border px-3 py-2 text-sm flex items-center gap-2 ${isDenied ? "border-red-500/40 bg-red-500/10 text-red-200" : "border-white/10 bg-white/[0.02] text-slate-300 hover:bg-white/[0.05]"}`}>
              <input
                type="checkbox"
                className="accent-red-500"
                checked={isDenied}
                onChange={(e) => {
                  const list = new Set(album.restrictions.services_denied);
                  if (e.target.checked) list.add(s); else list.delete(s);
                  setA("restrictions", { ...album.restrictions, services_denied: [...list] });
                }}
              />
              <span className="truncate">{s}</span>
            </label>
          );
        })}
        {filtered.length === 0 && (
          <div className="col-span-full text-center text-xs text-slate-500 py-6">No stores match &quot;{query}&quot;.</div>
        )}
      </div>
      <p className="mt-1.5 text-[11px] text-slate-500">Nothing checked → delivered to every partner store.</p>
    </div>
  );
}

export function TerritoryRestrictions({ album, setA }) {
  const denied = new Set(album.restrictions.territories_denied);
  const selectAll = () => setA("restrictions", { ...album.restrictions, territories_denied: [...TERRITORIES] });
  const denyAll = () => setA("restrictions", { ...album.restrictions, territories_denied: [] });
  return (
    <div>
      <div className="flex items-end justify-between gap-3 mb-2">
        <label className={labelCls + " mb-0"}>Territory restrictions — check regions you want to block</label>
        <div className="flex items-center gap-3 text-[11px]">
          <span className="text-slate-500" data-testid="territories-denied-count">{denied.size} / {TERRITORIES.length} blocked</span>
          <button type="button" data-testid="territories-select-all" onClick={selectAll} className="text-blue-400 hover:text-blue-300">Select All</button>
          <button type="button" data-testid="territories-deny-all" onClick={denyAll} className="text-slate-400 hover:text-white">Deny All</button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {TERRITORIES.map((t) => {
          const isDenied = denied.has(t);
          return (
            <label key={t} className={`cursor-pointer rounded-xl border px-3 py-2 text-sm flex items-center gap-2 ${isDenied ? "border-red-500/40 bg-red-500/10 text-red-200" : "border-white/10 bg-white/[0.02] text-slate-300"}`}>
              <input
                type="checkbox"
                className="accent-red-500"
                checked={isDenied}
                onChange={(e) => {
                  const list = new Set(album.restrictions.territories_denied);
                  if (e.target.checked) list.add(t); else list.delete(t);
                  setA("restrictions", { ...album.restrictions, territories_denied: [...list] });
                }}
              />
              {t}
            </label>
          );
        })}
      </div>
      <p className="mt-1.5 text-[11px] text-slate-500">Nothing checked → distributed worldwide.</p>
    </div>
  );
}
